<template>
  <div class="subjectBtn" :class="[isActive ? 'selectedBtn' : '']" :style="getSubjectBtnStyle(isActive)">
    <span :style="isActive ? `color: ${honorRollConfig.subjectTextActiveColor}` : `color: ${honorRollConfig.subjectTextNormalColor}`">{{text}}</span>
  </div>
</template>

<script>
export default {
  name:'subjectBtn',
  props:{
    text:{
      type:String,
      default:'英语'
    },
    isActive:{
      type:Boolean,
      default: false,
    },
    honorRollConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getSubjectBtnStyle(isActive) {
      const imageUrl = isActive ? this.honorRollConfig.subjectBtnActive : this.honorRollConfig.subjectBtnNormal;
      
      // 如果URL为空，返回空对象让CSS默认样式生效
      if (!imageUrl || !imageUrl.trim()) {
        return {};
      }
      
      // 如果有URL，使用内联样式覆盖CSS默认样式
      return {
        backgroundImage: `url(${imageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: '100% 100%'
      };
    },
  }
}
</script>
<style lang="less" scoped>
html{

  background: linear-gradient(180deg, #001F6D 0%, #081F65 100%);
}
</style>
<style lang="less" scoped>

.subjectBtn {
  width: 196px;
  height: 88px;
  background: url("../../../assets/images/winterGame/btn_normal.png") no-repeat;
  background-size: cover;
  font-size: 32px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #FFFFFF;
  text-align: center;
  line-height: 68px;
  }
.selectedBtn{
  background: url("../../../assets/images/winterGame/btn_selected.png") no-repeat;
  background-size: cover;
  color: #ffffff;
}



</style>
